import { css } from "@emotion/react";
import { Icon } from "@minted/minted-components";
import React, { memo } from "react";

const OFFSET_PX = 15;

const styles = {
  // Deliberately un-themed: this sits on top of a host's photo, so it needs the
  // same white-on-shadow contrast whatever the design's palette is.
  editButton: css`
    align-items: center;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    color: #333333;
    cursor: pointer;
    display: flex;
    font-size: 25px;
    height: 50px;
    justify-content: center;
    line-height: 1;
    text-align: center;
    width: 50px;
  `,
  wrapper: css`
    position: absolute;
    right: ${OFFSET_PX}px;
    top: ${OFFSET_PX}px;
    z-index: 999;
  `,
};

export type FrameEditPencilProps = {
  onEdit: () => void;
};

/**
 * Top-right pencil for a position:relative media frame (e.g. Marquee).
 * Travels with the frame under CSS transforms — unlike EditableHeader's
 * fixed absolute overlays.
 */
const FrameEditPencil = ({ onEdit }: FrameEditPencilProps) => (
  <div css={styles.wrapper}>
    <div css={styles.editButton} onClick={onEdit}>
      <Icon type={Icon.types.editSquare} />
    </div>
  </div>
);

const MemoizedFrameEditPencil = memo(FrameEditPencil);

export default MemoizedFrameEditPencil;
